var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.channelName)?_c('a-avatar',{attrs:{"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.channelName.substring(0, 1))+" ")]):_c('a-avatar',{attrs:{"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.channelNo)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }